// @ts-nocheck
import React from 'react'

const ChooseOption = ({ id, label, element_option, required, onInputChange }) => {
    const handleInputChange = event => {
        onInputChange(label, event.target.value);
    };
    return (
        <fieldset className="mb-6">
            <legend className="mb-2 block text-sm font-semibold text-slate-800"><span data-i18n-ignore="true">{label}</span>
            {required && <span className="text-red-500"> *</span>}
            </legend>
            <div className="grid gap-2 sm:grid-cols-2">
            {element_option.map((option) => (
                <label key={option} htmlFor={`${id}-${option}`} className="flex cursor-pointer items-center gap-3 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3 text-sm text-slate-700 transition hover:border-emerald-300 hover:bg-emerald-50/60">
                    <input
                        type="radio"
                        id={`${id}-${option}`}
                        name={id}
                        value={option}
                        onChange={handleInputChange}
                        required={required}
                        className="h-4 w-4 border-slate-300 text-emerald-700 focus:ring-emerald-500"
                    />
                    <span data-i18n-ignore="true">{option}</span>
                </label>
            ))}
            </div>
        </fieldset>
    )
}

export default ChooseOption
